type FilterKey = number | string;

export default (options: { name: string; id: number }[], idAsValue = false) =>
  options.reduce<{ [key in FilterKey]: string | number }>((acc, curr) => {
    acc[idAsValue ? curr.id : curr.name] = curr.name;
    return acc;
  }, {});
